import React from 'react';

import { CollapsePanel } from '@nxte-nl/collapse-panel';
import { stateHooks } from '@nxte-nl/state-hooks';

import { Accordion } from '../HeaderMenuContentFooter/HeaderMenuContentFooter';
import { Link, LinkIntent, LinkType } from '../Link/Link';
import { Typography, TypographyColor } from '../Typography/Typography';
import { Chevron, ChevronColor } from '../icons/Chevron/Chevron';
import styles from './HeaderMenuContentFooterAccordionItem.module.css';

export type Props = {
  itemLink: Accordion;
};

export const HeaderMenuContentFooterAccordionItem = React.memo((props: Props) => {
  const {
    itemLink,
  } = props;

  const {
    value: isAccordionExpanded,
    toggle: handleOnClickAccordion,
  } = stateHooks.useBooleanState();

  return (
    <CollapsePanel
      className={styles.wrapper}
      title={
        <div className={styles.itemContent}>
          <div className={styles.collapsePanel}>
            <div className={styles.itemIcon}>{itemLink.icon}</div>
            <Typography color={TypographyColor.Tertiary}>{itemLink.text}</Typography>
          </div>
          <Chevron
            variant={isAccordionExpanded ? 'up' : 'down'}
            fill={ChevronColor.accentWhite}
          />
        </div>
      }
      chevronState={false}
      onToggle={handleOnClickAccordion}
    >
      <div className={styles.accordionItems}>
        {itemLink.dropdownItems?.map(item => (
          item.path?.href && <Link
            type={LinkType.Href}
            to={item.path.href}
            withoutHoverStyles={true}
            intent={LinkIntent.tertiary}
            key={item.path.href}
          >
            <div key={item.path.href} className={styles.accordionItem}>
              {item.title}
            </div>
          </Link>
        ))}
      </div>
    </CollapsePanel>
  );
});

HeaderMenuContentFooterAccordionItem.displayName = 'HeaderMenuContentFooterAccordionItem';
